import { useEffect, useRef } from 'react'
import {
  pluginCommerceDemoConfig as cfg,
  isDemoConfigured,
} from '../config/pluginCommerceDemo'

/**
 * Montuje widżet Plugin Commerce dokładnie tak, jak robi to partner na swojej
 * stronie: wstrzykuje `<script src=loader.js data-*>` do kontenera, a loader
 * sam podstawia iframe wskazujący na aplikację embed.
 *
 * Kontener ma id `spotto-embed` i przekazujemy je loaderowi przez
 * `data-target`, żeby widżet zakotwiczył się tutaj, a nie na końcu <body>.
 *
 * Wstrzyknięcie odraczamy o makrozadanie i anulujemy je w cleanupie. W React
 * StrictMode (dev) efekt odpala się podwójnie: mount → cleanup → mount. Bez
 * odroczenia wyrzucany przebieg zdążyłby dołożyć `<script async>`, który
 * loaduje się asynchronicznie i montuje iframe już PO cleanupie, dając dwa
 * widżety (loader nie dedupuje: `MOUNTED` trzyma osobne elementy <script>).
 * clearTimeout w cleanupie sprawia, że wyrzucany przebieg nigdy nie wstrzykuje
 * skryptu, więc zostaje dokładnie jeden iframe.
 */
export default function EmbedMount() {
  const hostRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const host = hostRef.current
    if (!host || !isDemoConfigured(cfg)) return

    let cancelled = false
    const timer = window.setTimeout(() => {
      if (cancelled) return
      host.innerHTML = '' // czysty kontener, gdyby coś zostało

      const script = document.createElement('script')
      script.src = cfg.loaderUrl
      script.async = true
      script.setAttribute('data-business-id', cfg.businessId)
      script.setAttribute('data-embed-token', cfg.embedToken)
      script.setAttribute('data-mode', cfg.mode)
      script.setAttribute('data-target', '#spotto-embed')
      for (const [key, value] of Object.entries(cfg.dataset ?? {})) {
        script.setAttribute(`data-${key}`, value)
      }
      host.appendChild(script)
    }, 0)

    return () => {
      cancelled = true
      window.clearTimeout(timer)
      // Sprząta skrypt i iframe wstrzyknięte przez loader.
      host.innerHTML = ''
    }
  }, [])

  return <div id="spotto-embed" ref={hostRef} className="min-h-[420px]" />
}
